import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./check-box.scss";

const CheckBox = ({
  icon,
  iconPosition,
  textDescription,
  active,
  wrapperStyles,
  className,
  handlerClick,
  ...rest
}) => {
  return (
    <div className={wrapperStyles}>
      <button
        type="button"
        className={`${className || "check-box-container"}`}
        onClick={handlerClick}
        {...rest}
      >
        {iconPosition === "right" && (
          <span className="check-box">
            {active && <FontAwesomeIcon icon={icon} />}
          </span>
        )}

        <span className="check-description">{textDescription}</span>

        {iconPosition === "left" && (
          <span className="check-box">
            {active && <FontAwesomeIcon icon={icon} />}
          </span>
        )}
      </button>
    </div>
  );
};

CheckBox.defaultProps = {
  icon: "check",
  iconPosition: "right",
  textDescription: "",
  wrapperStyles: "",
  className: "",
};

CheckBox.propTypes = {
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(["right", "left"]),
  textDescription: PropTypes.string,
  active: PropTypes.bool.isRequired,
  wrapperStyles: PropTypes.string,
  className: PropTypes.string,
  handlerClick: PropTypes.func.isRequired,
};

export default CheckBox;
